import React from 'react';
import styled from 'styled-components';

const Separation = {
    0: {
        text: "10件ずつ",
        count: 10
    },
    1: {
        text: "20件ずつ",
        count: 20
    },
    2: {
        text: "50件ずつ",
        count: 50
    },
    3: {
        text: "すべて",
        count: -1
    }
}
class Pagenation {
    constructor(props) {
        this.SeparationIndex = 0;
    }
    getPageIndex = (list, current, callback) => { 
        if(Separation[this.SeparationIndex].count === -1) return;
        let count = Math.ceil(list.length / Separation[this.SeparationIndex].count);
        let page = [];
        if(count > 10) {
            let start;
            let end;
            if(current < 5) {
                start = 0;
            } else {
                start = current - 5;
            }
            if(start + 10 < count) {
                end = start + 10;
            } else {
                end = count;
            }
            let prev = current === 0 ? 0 : current - 1;
            let next = current + 1 === count ? count - 1 : current + 1;
            page.push(
                <PageIndexPN key="prev" onClick={() => callback(prev)}>
                    <i className="fas fa-chevron-left"></i>
                </PageIndexPN>
            );
            for(let i = start; i < end; i++) {
                page.push(
                    <PageIndex key={i} Current={i === current} onClick={() => callback(i)}></PageIndex>
                );
            }
            page.push(
                <PageIndexPN key="next" onClick={() => callback(next)}>
                    <i className="fas fa-chevron-right"></i>
                </PageIndexPN>
            );
        } else {
            for(let i = 0; i < count; i++) {
                page.push(
                    <PageIndex key={i} Current={i === current} onClick={() => callback(i)}></PageIndex>
                );
            }
        }
        let pageInfo;
        if(count > 0) {
            pageInfo = (
                <PageInfo>
                    Page. {current} / {count-1}
                </PageInfo>
            );
        }
        return (
            <PageBody>
                {pageInfo}
                <PageIndexWrap>
                    {page}
                </PageIndexWrap>
            </PageBody>
        );
    }
    getList = (list, page) => {
        let separation = Separation[this.SeparationIndex].count;
        if(separation > 0 && separation * page < list.length) {
            return list.slice(separation * page, separation * page + separation);
        } else {
            return list.slice(separation * page);
        }
    }
    onChange = (e, callback) => {
        this.SeparationIndex = e.target.value;
        callback(e.target.value);
    }
    getSelector(callback) {
        let ret = [];
        let keys = Object.keys(Separation);
        for (let key in keys) {
            ret.push(
                <option key={key} value={key}>
                    {Separation[key].text}
                </option>
            );
        }
        return (
            <Select onChange={(e) => this.onChange(e, callback)} value={this.SeparationIndex}>
                {ret}
            </Select>
        )
    }
}

export {Pagenation};

const PageBody = styled.div`
    display: flex;
    flex-direction: column;
`;
const PageInfo = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
`;
const PageIndexWrap = styled.div`
    display: flex;
    justify-content: center;
`;

const PageIndex = styled.div`
    width: 10px;
    height: 10px;
    line-height: 10px;
    text-align: center;
    margin: 0 4px;
    color: ${props => props.Current ? "#fff" : "#888"};
    background-color: ${props => props.Current ? "#0077ff" : "#ccc"};
    font-weight: bold;
    border-radius: 50%;
    cursor: pointer;
`;
const PageIndexPN = styled.div`
    width: 10px;
    height: 10px;
    line-height: 10px;
    text-align: center;
    margin: 0 4px;
    color: #0077ff;
    cursor: pointer;
`;

const Select = styled.select`
    border: 1px solid #888;
    color: #888;
    padding: 3px 5px 3px 5px;
    border-radius: 5px;
    outline: none;
    margin: 0 10px;
    option:first-of-type {
        border-radius: 5px 5px 0 0;
    }
    option:last-of-type {
        border-radius: 0 0 5px 5px;
    }
`;
